import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const FEATURES = [
  {
    icon: "📲",
    title: "Digital Catalogue Instantly",
    desc: "Any shop live in 20 minutes. Customers scan QR, browse products, place orders — no app needed.",
  },
  {
    icon: "🎁",
    title: "Loyalty Rewards Built-in",
    desc: "Give points on every visit. Customers redeem free products. Referrals grow your business automatically.",
  },
  {
    icon: "📋",
    title: "Orders & Queue Management",
    desc: "Live orders on your dashboard. Token system for walk-ins. Appointments for salons and clinics.",
  },
  {
    icon: "🧾",
    title: "GST Billing & Invoices",
    desc: "Generate Tax Invoices and Bills of Supply in one tap. A4 and 80mm thermal formats supported.",
  },
];

const STEPS = [
  { n: "01", title: "Enter your number", desc: "Quick OTP — no passwords needed." },
  { n: "02", title: "Set up your shop", desc: "Name, category, your custom link." },
  { n: "03", title: "Add your products", desc: "Upload items with prices & photos." },
  { n: "04", title: "Share your QR", desc: "Customers scan and start ordering." },
];

const STATS = [
  { value: "20 min", label: "Setup time" },
  { value: "₹0", label: "During beta" },
  { value: "10+", label: "Business types" },
];

const VERTICALS = [
  { icon: "🥛", name: "Dairy" },
  { icon: "✂️", name: "Tailor" },
  { icon: "💈", name: "Salon" },
  { icon: "🛋️", name: "Furniture" },
  { icon: "🛒", name: "Grocery" },
  { icon: "🍨", name: "Falooda" },
  { icon: "💍", name: "Jewellery" },
  { icon: "🏕️", name: "Tent House" },
];

const C = {
  bg: "#0a0a0f",
  surface: "#111118",
  border: "#1e1e2e",
  accent: "#f5c542",
  accentDim: "#f5c54218",
  text: "#f0ede8",
  muted: "#7a7880",
};

export default function HomePage() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={S.root}>

      {/* NAV */}
      <nav style={S.nav}>
        <div style={S.navInner}>
          <span style={S.logo}>QKARD</span>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button style={S.navBtnGhost} onClick={() => navigate("/login")}>Sign In</button>
            <button style={S.navBtnPrimary} onClick={() => navigate("/signup")}>Get Started</button>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section style={S.hero}>
        <div style={{
          ...S.heroContent,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(28px)",
          transition: "opacity 0.7s ease, transform 0.7s ease",
        }}>
          <div style={S.badge}>🏪 Built for every Lucknow business</div>
          <h1 style={S.h1}>
            Your shop, digital.
            <br />
            <span style={S.h1Accent}>Customers keep coming back.</span>
          </h1>
          <p style={S.heroSub}>
            Digital catalogue, loyalty rewards, orders, billing — everything your shop needs.
            Any business live in 20 minutes. Free during beta.
          </p>
          <div style={S.heroCta}>
            <button style={S.btnPrimary} onClick={() => navigate("/signup")}>Start Free →</button>
            <a href="#how" style={S.btnGhost}>See how it works</a>
          </div>
          <p style={S.heroNote}>No credit card · Setup in 20 minutes · Free during beta</p>

          {/* Stats */}
          <div style={S.statsRow}>
            {STATS.map((s) => (
              <div key={s.label} style={S.statItem}>
                <div style={S.statValue}>{s.value}</div>
                <div style={S.statLabel}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Mock — Milkas Rewards card */}
        <div style={{
          ...S.mockWrap,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(40px)",
          transition: "opacity 0.85s ease 0.2s, transform 0.85s ease 0.2s",
        }}>
          <div style={S.mockCard}>
            {/* Header */}
            <div style={{ background: "#1a3a5c", padding: "16px", position: "relative", overflow: "hidden" }}>
              <div style={{ position: "absolute", top: -20, right: -20, width: 80, height: 80, background: "rgba(245,166,35,0.12)", borderRadius: "50%" }} />
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                <div style={{ width: 36, height: 36, background: "white", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>🥛</div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 14, color: "white" }}>Milkas Dairy</div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", letterSpacing: 1, textTransform: "uppercase" }}>Rewards Program</div>
                </div>
                <div style={{ marginLeft: "auto", textAlign: "right" }}>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)" }}>Hi,</div>
                  <div style={{ fontSize: 13, fontWeight: 800, color: "white" }}>Ravi</div>
                </div>
              </div>
              {/* Points card */}
              <div style={{ background: "rgba(255,255,255,0.08)", borderRadius: 12, padding: "14px", textAlign: "center" }}>
                <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Your Balance</div>
                <div style={{ fontSize: 42, fontWeight: 900, color: "white", lineHeight: 1 }}>85</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#f5a623", marginTop: 4, letterSpacing: 1 }}>MILKAS POINTS</div>
              </div>
            </div>

            {/* Offer banner */}
            <div style={{ background: "#1a3a5c", margin: "8px", borderRadius: 10, padding: "10px 14px", border: "1px solid rgba(245,166,35,0.3)", display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18 }}>🎉</span>
              <div>
                <div style={{ fontSize: 9, fontWeight: 800, color: "#f5a623", letterSpacing: 1.5, textTransform: "uppercase" }}>Aaj ka Special</div>
                <div style={{ fontSize: 12, fontWeight: 800, color: "white" }}>Free paneer 100gm today!</div>
              </div>
            </div>

            {/* Milestone bar */}
            <div style={{ padding: "10px 12px", borderBottom: `1px solid ${C.border}` }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, marginBottom: 6 }}>
                <span style={{ fontWeight: 700, color: C.text }}>🍼 Next: 500ml Milk</span>
                <span style={{ color: C.muted }}>15 pts away</span>
              </div>
              <div style={{ background: C.border, borderRadius: 20, height: 8, overflow: "hidden" }}>
                <div style={{ height: 8, width: "85%", background: "linear-gradient(90deg, #2563a8, #f5a623)", borderRadius: 20 }} />
              </div>
              <div style={{ fontSize: 10, color: C.muted, marginTop: 4 }}>85 / 100 points</div>
            </div>

            {/* Rewards */}
            <div style={{ padding: "10px 12px" }}>
              {[
                { name: "Free Curd 200g", pts: 100, eligible: false, icon: "🥛" },
                { name: "Free Milk 500ml", pts: 150, eligible: false, icon: "🍼" },
              ].map(r => (
                <div key={r.name} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0", borderBottom: `1px solid ${C.border}` }}>
                  <span style={{ fontSize: 18 }}>{r.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: C.text }}>{r.name}</div>
                    <div style={{ fontSize: 10, color: C.muted }}>Need {r.pts - 85} more points</div>
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 900, color: "#f5a623" }}>{r.pts} pts</div>
                </div>
              ))}
            </div>
          </div>

          {/* Floating badge */}
          <div style={S.floatingBadge}>
            🔔 +5 pts — Visit earned at Milkas!
          </div>
        </div>
      </section>

      {/* VERTICALS */}
      <section style={{ ...S.section, paddingTop: 40 }}>
        <p style={S.sectionLabel}>Works for every shop</p>
        <h2 style={{ ...S.h2, marginBottom: 32 }}>Any business. Any product. Any city.</h2>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center", marginBottom: 16 }}>
          {VERTICALS.map(v => (
            <div key={v.name} style={{
              background: C.surface, border: `1px solid ${C.border}`,
              borderRadius: 12, padding: "12px 20px",
              display: "flex", alignItems: "center", gap: 8,
              fontSize: 14, fontWeight: 600, color: C.text,
            }}>
              <span style={{ fontSize: 20 }}>{v.icon}</span>
              {v.name}
            </div>
          ))}
        </div>
        <p style={{ fontSize: 13, color: C.muted }}>More verticals being added. If your business isn't listed — <span style={{ color: C.accent, cursor: "pointer" }} onClick={() => navigate("/signup")}>sign up anyway.</span></p>
      </section>

      {/* FEATURES */}
      <section style={{ ...S.section, background: C.surface, maxWidth: "100%", padding: "80px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <p style={S.sectionLabel}>What you get</p>
          <h2 style={S.h2}>Everything your shop needs</h2>
          <div style={S.featureGrid}>
            {FEATURES.map((f) => (
              <div key={f.title} style={S.featureCard}>
                <div style={S.featureIcon}>{f.icon}</div>
                <div style={S.featureTitle}>{f.title}</div>
                <div style={S.featureDesc}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" style={{ ...S.section, padding: "80px 24px" }}>
        <p style={S.sectionLabel}>Simple process</p>
        <h2 style={S.h2}>Go live in under 20 minutes</h2>
        <div style={S.steps}>
          {STEPS.map((s, i) => (
            <div key={s.n} style={S.step}>
              <div style={S.stepNum}>{s.n}</div>
              <div style={S.stepBody}>
                <div style={S.stepTitle}>{s.title}</div>
                <div style={S.stepDesc}>{s.desc}</div>
              </div>
              {i < STEPS.length - 1 && <div style={S.stepArrow}>→</div>}
            </div>
          ))}
        </div>
      </section>

      {/* LOYALTY HIGHLIGHT */}
      <section style={{ background: C.surface, maxWidth: "100%", padding: "80px 24px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
          <p style={S.sectionLabel}>New — Loyalty Rewards</p>
          <h2 style={{ ...S.h2, marginBottom: 20 }}>Turn one-time buyers into regulars</h2>
          <p style={{ fontSize: 16, color: C.muted, lineHeight: 1.7, marginBottom: 40 }}>
            QKARD Rewards gives your customers points on every visit. They redeem free products.
            They refer friends. You get a full dashboard with member insights, offers, and push notifications —
            all without any registration or monthly fees.
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap", marginBottom: 40 }}>
            {[
              { icon: "📍", text: "GPS-verified visit points" },
              { icon: "🎁", text: "Redeem free products" },
              { icon: "👥", text: "Referral system built-in" },
              { icon: "🔔", text: "Push offer notifications" },
              { icon: "🚨", text: "Fraud detection" },
              { icon: "📊", text: "Member dashboard" },
            ].map(f => (
              <div key={f.text} style={{
                background: C.accentDim, border: `1px solid ${C.accent}33`,
                borderRadius: 100, padding: "8px 16px",
                fontSize: 13, fontWeight: 600, color: C.text,
                display: "flex", alignItems: "center", gap: 8,
              }}>
                {f.icon} {f.text}
              </div>
            ))}
          </div>
          <div style={{ fontSize: 13, color: C.muted, marginBottom: 20 }}>
            Live at <span style={{ color: C.accent, fontWeight: 700 }}>Milkas Dairy, Lucknow</span> — try it yourself:
          </div>
          <a
            href="https://qkard.app/rewards/milkas"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...S.btnPrimary, display: "inline-block", textDecoration: "none" }}
          >
            See Live Demo →
          </a>
        </div>
      </section>

      {/* CTA BAND */}
      <section style={S.ctaBand}>
        <div style={S.ctaInner}>
          <h2 style={S.ctaTitle}>Ready to modernise your shop?</h2>
          <p style={S.ctaSub}>
            Join shop owners using QKARD across Lucknow. Free during beta — no credit card needed.
          </p>
          <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
            <button style={S.btnPrimary} onClick={() => navigate("/signup")}>Get Started Free →</button>
            <button
              style={{ ...S.btnPrimary, background: "transparent", border: `1px solid ${C.accent}`, color: C.accent }}
              onClick={() => navigate("/login")}
            >
              Sign In
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={S.footer}>
        <span style={S.logo}>QKARD</span>
        <span style={S.footerNote}>© 2026 SyncField Global · qkard.app</span>
      </footer>

    </div>
  );
}

/* ─── COLOURS ─────────────────────────────────────────── */
const S = {
  root: {
    background: C.bg, color: C.text,
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    minHeight: "100vh", overflowX: "hidden",
  },
  nav: {
    position: "sticky", top: 0, zIndex: 100,
    background: C.bg + "ee", backdropFilter: "blur(12px)",
    borderBottom: `1px solid ${C.border}`,
  },
  navInner: {
    maxWidth: 1100, margin: "0 auto", padding: "0 24px",
    height: 60, display: "flex", alignItems: "center", justifyContent: "space-between",
  },
  logo: {
    fontFamily: "'DM Mono', monospace", fontWeight: 700,
    fontSize: 20, letterSpacing: "0.12em", color: C.accent,
  },
  navBtnGhost: {
    background: "transparent", border: `1px solid ${C.border}`,
    color: C.text, padding: "7px 18px", borderRadius: 8,
    fontSize: 14, cursor: "pointer",
  },
  navBtnPrimary: {
    background: C.accent, border: "none", color: "#0a0a0f",
    padding: "7px 18px", borderRadius: 8, fontSize: 14,
    fontWeight: 700, cursor: "pointer",
  },
  hero: {
    maxWidth: 1100, margin: "0 auto",
    padding: "80px 24px 80px",
    display: "flex", alignItems: "center",
    gap: 40, flexWrap: "wrap",
    overflow: "hidden",
  },
  heroContent: { flex: "1 1 380px", minWidth: 0 },
  badge: {
    display: "inline-block", background: C.accentDim,
    color: C.accent, border: `1px solid ${C.accent}44`,
    borderRadius: 100, padding: "4px 14px",
    fontSize: 13, fontWeight: 500, marginBottom: 24,
  },
  h1: {
    fontSize: "clamp(2rem, 4.5vw, 3.2rem)", fontWeight: 700,
    lineHeight: 1.15, letterSpacing: "-0.02em", margin: "0 0 20px",
  },
  h1Accent: { color: C.accent },
  heroSub: {
    fontSize: 17, color: C.muted, lineHeight: 1.65,
    maxWidth: 460, margin: "0 0 32px",
  },
  heroCta: { display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" },
  btnPrimary: {
    background: C.accent, color: "#0a0a0f", border: "none",
    padding: "13px 26px", borderRadius: 10, fontSize: 15,
    fontWeight: 700, cursor: "pointer", letterSpacing: "0.01em",
  },
  btnGhost: {
    color: C.muted, fontSize: 15, textDecoration: "none",
    borderBottom: `1px solid ${C.border}`, paddingBottom: 2,
  },
  heroNote: { marginTop: 14, fontSize: 13, color: C.muted },
  statsRow: { display: "flex", gap: 32, marginTop: 40 },
  statItem: {},
  statValue: { fontSize: 24, fontWeight: 800, color: C.accent, letterSpacing: "-0.02em" },
  statLabel: { fontSize: 12, color: C.muted, marginTop: 2 },
  mockWrap: {
    flex: "0 0 300px", maxWidth: "100%",
    position: "relative", overflow: "visible",
    paddingBottom: 30,
  },
  mockCard: {
    background: C.surface, border: `1px solid ${C.border}`,
    borderRadius: 20, overflow: "hidden",
    boxShadow: "0 32px 80px #00000088",
    width: "100%",
  },
  floatingBadge: {
    position: "absolute", bottom: 0, left: "50%",
    transform: "translateX(-50%)",
    background: "#0f1f0f", border: "1px solid #22c55e44",
    color: "#22c55e", borderRadius: 100,
    padding: "6px 16px", fontSize: 12, fontWeight: 600,
    whiteSpace: "nowrap",
    boxShadow: "0 4px 20px #00000066",
  },
  section: {
    maxWidth: 1100, margin: "0 auto",
    padding: "80px 24px", textAlign: "center",
  },
  sectionLabel: {
    fontSize: 12, fontWeight: 600, letterSpacing: "0.15em",
    textTransform: "uppercase", color: C.accent, marginBottom: 12,
  },
  h2: {
    fontSize: "clamp(1.6rem, 3.5vw, 2.4rem)", fontWeight: 700,
    letterSpacing: "-0.02em", margin: "0 0 48px",
  },
  featureGrid: {
    display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 20, textAlign: "left",
  },
  featureCard: {
    background: C.bg, border: `1px solid ${C.border}`,
    borderRadius: 14, padding: "24px 22px",
  },
  featureIcon: { fontSize: 28, marginBottom: 14 },
  featureTitle: { fontWeight: 700, fontSize: 15, marginBottom: 8 },
  featureDesc: { fontSize: 14, color: C.muted, lineHeight: 1.6 },
  steps: {
    display: "flex", flexWrap: "wrap", gap: 0,
    justifyContent: "center",
  },
  step: {
    display: "flex", flexDirection: "column", alignItems: "center",
    flex: "1 1 160px", position: "relative", padding: "0 10px",
  },
  stepNum: {
    fontFamily: "'DM Mono', monospace", fontSize: 28,
    fontWeight: 700, color: C.accent, marginBottom: 12,
  },
  stepBody: { textAlign: "center" },
  stepTitle: { fontWeight: 700, fontSize: 15, marginBottom: 6 },
  stepDesc: { fontSize: 13, color: C.muted, lineHeight: 1.6 },
  stepArrow: { position: "absolute", right: -14, top: 8, fontSize: 20, color: C.border },
  ctaBand: {
    background: C.accentDim, border: `1px solid ${C.accent}33`,
    margin: "60px 24px",
    borderRadius: 20, padding: "60px 24px",
  },
  ctaInner: { maxWidth: 600, margin: "0 auto", textAlign: "center" },
  ctaTitle: {
    fontSize: "clamp(1.6rem, 3vw, 2.2rem)", fontWeight: 700,
    margin: "0 0 12px", letterSpacing: "-0.02em",
  },
  ctaSub: { fontSize: 16, color: C.muted, margin: "0 0 28px" },
  footer: {
    borderTop: `1px solid ${C.border}`, padding: "24px",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    maxWidth: 1100, margin: "0 auto",
  },
  footerNote: { fontSize: 13, color: C.muted },
};
